import { Typography, Button } from '@mui/material'
import  { Box } from '@mui/material';

export function ParcelCard ({text = '', imageName = '', imgScale = 1, translateX = '0%', translateY = '0%', onClick = () => {}}) {

    const style = {
        img: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            transform: `scale(${imgScale}) translateX(${translateX}) translateY(${translateY})`,
            objectPosition: 'center'
        },
        text: { 
            textAlign: 'center',
            fontStyle: 'italic',
            minHeight: '3rem',
        },
    };

    return (
        <Box sx={{ 
            backgroundColor: '#FFFFFF', 
            padding: '1rem', 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            width: '100%', 
            boxSizing: 'border-box',
            height: '100%',
        }}>
            <Box sx={{ borderRadius: 2.5, overflow: 'hidden', width: '100%', maxWidth: '12rem', aspectRatio: '1/1', marginBottom: '0.7rem' }}>
                <img 
                    src={`${process.env.PUBLIC_URL}/img/${imageName}`} 
                    alt="parcel"
                    style={style.img}
                />
            </Box>
            <Typography variant='h5' sx={style.text}>
                {text}
            </Typography>
            <Button variant='contained' sx={{ textTransform: 'none', marginTop: '1rem', paddingInline: '1.5rem'}} onClick={onClick}>
                Tutoriel
            </Button>
        </Box>
    );
}

export default ParcelCard;